// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckActivitiesList_container__f6glH","checklist":"CheckActivitiesList_checklist__OgPTn","checkbox":"CheckActivitiesList_checkbox__3yDEr"};